import React from 'react';
import Card from '@mui/material/Card';
import FilterIcon from '../../icons/FilterIcon';
import { Box } from '@mui/material';

export default function Nodata() {
    return (
        <>
            <Box border={1} borderLeft={1} borderRight={1} borderColor="#e4e7ec"  sx={{ padding: 2, marginTop: 4, marginRight: "12px", width: "auto" }} className="text-center">
                <span style={{ color: "#667085" }}>No Result Found</span>
            </Box>
        </>
    )
}